<template lang="jade">
.tab-selector-background(v-bind:class="{ 'selecting-tab': selectingTab }")
.tab-selector-shadow(v-if="isshadow")
.tab-selector.text-center(v-bind:id="selectorid", v-bind:class="{'selecting-tab': selectingTab, 'sticky': isSticky }", :selected="synctab", )
  mdl-tabs.responsive-mdl(:selected.sync="synctab", @click="selectingTabToggle")
    span.tab-select-icon
      i.fa.fa-angle-left.fa-2x
    mdl-tab( v-for="tab in tabs" ':tab'="tab")
</template>

<script>
export default {
  data () {
    return {
      selectingTab: false,
    }
  },
  props: {
    selectorid: {
      type: String,
    },
    tabs: {
      type: Array,
      required: true
    },
    synctab: {
      required: true
    },
    isshadow: {
      type: Boolean,
      default: true
    },
    isSticky: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pathObj () {
      return {
        path: this.path
      }
    },
  },
  ready () {},
  attached () {},
  methods: {
    selectingTabToggle() {
      this.selectingTab = this.selectingTab ? false : true;
    },
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import "global";

.sticky {
  background: #FFF;
  @media (max-width: $grid-float-breakpoint-max) {
    background: rgba(0, 0, 0, 0);
  }
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 68px;
}
.mdl-tabs.responsive-mdl {
  .tab-select-icon {
    display: none;

    @media (max-width:$grid-float-breakpoint-max) {
      display: inherit;
      position: absolute;
      top: 5px;
      right: 22px;
      height: $responsive-mdl-selector-height;
      z-index: 1;
      font-size: 14px;
      line-height: $responsive-mdl-selector-height;
      text-align: center;
      > i {
        transform: rotate(-90deg);
        transition: transform 0.2s;
      }
    }
  }
}

@media (max-width:$grid-float-breakpoint-max) {
  .mdl-tabs.responsive-mdl {
    border-top: $responsive-mdl-selector-border;
  }
  .tab-selector-background {
    &.selecting-tab {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 100;
      background-color: rgba(0,0,0,0.6);
    }
  }
  .tab-selector {
    z-index: 99;
    height: $responsive-mdl-selector-height;
    padding: 0;
    margin: 0;
    left: 0;
    right: 0;
    position: fixed;
    top: 56px;
    width: 100%;
    &.selecting-tab {
      z-index: 101;
    }
  }
  .tab-selector-shadow {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.13);
    width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    height: 10px;
    top: $responsive-mdl-selector-height + 46px;
    z-index: 98;
  }
}
</style>

<style lang="scss">
@import "global";
@media (max-width:$grid-float-breakpoint-max) {
  .mdl-tabs.responsive-mdl {
    .mdl-tabs__tab-bar {
      display: block;
      height: $responsive-mdl-selector-height;
      margin: 0;
      > .mdl-tabs__tab {
        margin: 0;
        width: 100%;
        background-color: $responsive-mdl-selector-background-color;
        height: 0px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      > .mdl-tabs__tab.is-active {
        height: $responsive-mdl-selector-height;
        padding: $responsive-mdl-label-padding;
        border-bottom: $responsive-mdl-selector-border;
      }
    }
  }

  .tab-selector.selecting-tab {
    .mdl-tabs.responsive-mdl {
      .mdl-tabs__tab, .mdl-tabs__tab.is-active {
        padding: 2px 4px 2px 4px;
        height: $responsive-mdl-selector-height;
        border-bottom: $responsive-mdl-selector-border;
      }
      .tab-select-icon > i {
        transform: rotate(90deg);
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// second-menu.vue?60b161e1